import React from 'react'
import { useGlobalState } from 'state'
import { LAYERS } from 'common/layers'
import * as api from 'common/api'

export const HinanAreaLayer = () => {
  const layerIds = [LAYERS.SCHOOL_AREA_RISK.id, LAYERS.SCHOOL_AREA_RISK_BLACK.id, LAYERS.SCHOOL_AREA_RISK_PURPLE.id]
  const { app, map, mapbox } = useGlobalState()

  React.useEffect(() => {
    if (!mapbox) return
    updateFilter()
    return () => {
      invisibleLayer()
    }
  }, [mapbox])

  React.useEffect(() => {
    syncHinanArea()
  }, [app.baseDate])

  React.useEffect(() => {
    updateFilter()
  }, [app.hinanData])

  const syncHinanArea = async () => {
    const res = await api.get('/any-timeseries', {
      bucket: 'ctie.shizuoka.web',
      prefix: 'hinan/data/',
      date: app.getFormattedBaseDate()
    })
    if (res === null || res.data === undefined) {
      app.setHinanData({})
    } else {
      app.setHinanData(res.data)
    }
  }

  const updateFilter = async () => {
    if (!mapbox) return
    layerIds.forEach(layerId => {
      if (!mapbox.getLayer(layerId)) return
      const filter: maplibregl.ExpressionSpecification = ['any']
      Object.keys(app.hinanData).map(name => {
        const data = app.hinanData[name]
        let maxLevel = 0
        data.map((d: any) => {
          let level = 0
          if (d.alertLevel === '警戒レベル3' || d.alertLevel === '警戒レベル３') level = 3
          if (d.alertLevel === '警戒レベル4' || d.alertLevel === '警戒レベル４') level = 4
          if (d.alertLevel === '警戒レベル5' || d.alertLevel === '警戒レベル５') level = 5
          if (maxLevel < level) {
            maxLevel = level
          }
        })
        if (layerId === LAYERS.SCHOOL_AREA_RISK_BLACK.id && maxLevel < 5) {
          return
        } else if (layerId === LAYERS.SCHOOL_AREA_RISK_PURPLE.id && maxLevel < 4) {
          return
        }
        filter.push(['==', ['get', 'NAME'], name])
      })
      if (filter.length === 1) {
        filter.push(['==', ['get', 'NAME'], 'dammy'])
      }
      map.setLayerFilter(layerId, filter)
    })
  }

  const invisibleLayer = () => {
    layerIds.forEach(layerId => {
      map.mapbox?.setLayoutProperty(layerId, 'visibility', 'none')
    })
  }

  return <></>
}
